var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00081 0.432617C4.41748 0.432617 0.66748 4.18262 0.66748 8.76595C0.66748 13.3493 4.41748 17.0993 9.00081 17.0993C13.5841 17.0993 17.3341 13.3493 17.3341 8.76595C17.3341 4.18262 13.5841 0.432617 9.00081 0.432617ZM12.5841 6.76595L8.75081 11.766C8.58415 11.9326 8.33415 12.0993 8.08415 12.0993C7.83415 12.0993 7.58415 12.016 7.41748 11.766L5.41748 9.18262C5.16748 8.84928 5.16748 8.26595 5.58415 8.01595C6.00081 7.76595 6.50081 7.76595 6.75081 8.18262L8.08415 9.93262L11.2508 5.76595C11.5008 5.43262 12.0841 5.34928 12.4175 5.59928C12.8341 5.84928 12.8341 6.34928 12.5841 6.76595Z",
    fill: "#1EB386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductActive);
export default __webpack_public_path__ + "static/media/ProductActive.42c36eb750af99f1c2547927823e1ae7.svg";
export { ForwardRef as ReactComponent };